import './style.scss';
import Swiper from 'swiper';
import 'swiper/css';

document.addEventListener('DOMContentLoaded', function() {
    const sliders = document.querySelectorAll('.kjb-slider__swiper');
    
    sliders.forEach((slider) => {
        const wrapper = slider.querySelector('.kjb-slider__swiper-wrapper');
        const originalSlides = Array.from(slider.querySelectorAll('.kjb-slider-item'));
        let slideCount = originalSlides.length;
        
        // data-auto-slides-per-view属性を取得
        const autoSlidesPerView = slider.dataset.autoSlidesPerView === 'true';
        
        // スライドが6枚未満の場合、複製して6枚以上にする
        if (slideCount < 6) {
            const duplicatesNeeded = Math.ceil(6 / slideCount);
            for (let i = 1; i < duplicatesNeeded; i++) {
                originalSlides.forEach(slide => {
                    const clone = slide.cloneNode(true);
                    wrapper.appendChild(clone);
                });
            }
            slideCount = wrapper.querySelectorAll('.kjb-slider-item').length;
        }
        
        new Swiper(slider, {
            // modules: [Autoplay],
            loop: true,
            loopedSlides: slideCount,
            watchSlidesProgress: true,
            /* autoplay: {
                delay: 1000,
                disableOnInteraction: false,
            }, */
            slidesPerView: autoSlidesPerView ? 'auto' : 2.6,
            spaceBetween: 8,
            centeredSlides: true,
            breakpoints: {
                768: {
                    slidesPerView: autoSlidesPerView ? 'auto' : 3.6,
                    spaceBetween: 24,
                    centeredSlides: false,
                }
            }
        });
    });
});
